import styled from "@emotion/styled";

export const StyledLightboxImage = styled.img<{
  zoom: number;
  offsetX: number;
  offsetY: number;
  isPannable: boolean;
  isPanning: boolean;
  isTouchInteracting: boolean;
}>`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: ${({ theme }) => theme.borderRadius.large};
  transform: translate3d(${({ offsetX }) => offsetX}px, ${({ offsetY }) => offsetY}px, 0)
    scale(${({ zoom }) => zoom});
  transform-origin: center center;
  transition: transform
    ${({ isPanning, isTouchInteracting }) =>
      isPanning || isTouchInteracting ? "0s" : "0.15s ease"};
  touch-action: none;
  user-select: none;
  cursor: ${({ isPannable, isPanning }) =>
    isPannable ? (isPanning ? "grabbing" : "grab") : "default"};
`;
